import React, { FC } from 'react';
import Icon from '@common/assets';
import EllipsisText from '@common/ellipsisText';
import { JobOpeningImageListItemVO } from '@domain/vo/common/JobOpeningImageListItemVO';
import Image from '@components/common/image';
import Colors from '@domain/constant/colors';

import classnames from 'classnames/bind';
import styles from './jobOpeningImageListItem.module.scss';
const cx = classnames.bind(styles);

interface JobOpeningImageListItemProps {
  positionData: JobOpeningImageListItemVO;
  onOpenJobPostModal: () => void;
}

const JobOpeningImageListItem: FC<JobOpeningImageListItemProps> = ({ positionData, onOpenJobPostModal }) => {
  const { companyName, positionName, postEndDateTime, dDay, companyLogoUrl, representativeImageUrl } = positionData;
  const logoImage = companyLogoUrl ? `url('${companyLogoUrl}')` : '';

  return (
    <a className={cx('listItem')} role="button" onClick={onOpenJobPostModal}>
      <div className={cx('imgArea')}>
        {representativeImageUrl && <Image src={representativeImageUrl} alt="company image" fill pointer />}
      </div>
      <div className={cx('companyInfoArea')}>
        <div className={cx('logo', { default: !logoImage })}>
          {companyLogoUrl ? (
            <Image src={companyLogoUrl} alt="logo" width={48} height={48} />
          ) : (
            <Icon name="logo" width={32} height={7} fill={Colors.C_COOL_GRAY_50} />
          )}
        </div>
        <div className={cx('companyName')}>{companyName}</div>

        <EllipsisText
          text={positionName}
          type={'width'}
          offset={216}
          customClassName={cx('jobPostTitleWrap')}
          tooltipType={'top'}
        />

        <div className={cx('dateArea')}>
          {postEndDateTime && <div className={cx('date')}>{postEndDateTime}</div>}
          {dDay && <div className={cx('dDay')}>{dDay}</div>}
        </div>
      </div>
    </a>
  );
};

export default JobOpeningImageListItem;
